import { PropsWithChildren, useEffect, useState } from 'react'
import ErrorAlert from './ErrorAlert'
import { useTranslation } from 'react-i18next'

export default function ViewportCheckProvider({
  children
}: Readonly<PropsWithChildren>) {
  const [isViewportTooSmall, setIsViewportTooSmall] = useState(
    window.innerWidth < 360
  )

  const { t } = useTranslation('ui-init')

  const testIdInit = 'viewport-check'

  useEffect(() => {
    const handleResize = () => {
      setIsViewportTooSmall(window.innerWidth < 360)
    }
    window.addEventListener('resize', handleResize)
    return () => {
      document.removeEventListener('resize', handleResize)
    }
  }, [])

  if (isViewportTooSmall) {
    return (
      <ErrorAlert data-testid={`${testIdInit}-error`}>
        {t('viewport_check_provider.error')}
      </ErrorAlert>
    )
  }

  return children
}
